import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, provisioningPath } from '@/lib/api-client';
import { isTerminalStatus, type ProvisioningTask } from '@/types/provisioning';

import { provisioningKeys } from './provisioning-keys';

/**
 * Polls a provisioning task's status (GET /tasks/:task_id) every 2s until it
 * reaches a terminal state (success/failed/stopped), then stops polling.
 */
export function useProvisioningTask(
  taskId: number | undefined,
): UseQueryResult<ProvisioningTask, Error> {
  return useQuery({
    queryKey: provisioningKeys.task(taskId ?? -1),
    enabled: Boolean(taskId),
    queryFn: ({ signal }) =>
      apiClient.get<ProvisioningTask>(provisioningPath(`/tasks/${taskId}`), signal),
    refetchInterval: (q) => (isTerminalStatus(q.state.data?.status) ? false : 2_000),
    refetchIntervalInBackground: false,
  });
}
